import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MsalService } from './msal.service';
import { Injectable, Inject } from '@angular/core';
import { Location } from "@angular/common";
import { InteractionType, AuthenticationResult } from "@azure/msal-browser";
import { MsalGuardConfiguration } from './msal.guard.config';
import { MSAL_GUARD_CONFIG } from './constants';
import { concatMap, catchError, map, switchMap } from 'rxjs/operators';
import { Observable, of, from, EMPTY } from 'rxjs';
import { Minimatch } from "minimatch"; // NOSONAR
import { MSAL_INTERCEPTOR_CONFIG } from './constants';
import { MsalInterceptorConfig } from './msal.interceptor.config';
import { TaskManagerStateService } from '../service/taskmanager-state.service';
import { Router } from '@angular/router';
import { UsersService } from '../service/users.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FgaService } from '../fga/fga.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class MsalGuard  {
	constructor(
		@Inject(MSAL_GUARD_CONFIG) private readonly msalGuardConfig: MsalGuardConfiguration,
		@Inject(MSAL_INTERCEPTOR_CONFIG) private readonly msalInterceptorConfig: MsalInterceptorConfig,
		private readonly authService: MsalService,
		private readonly location: Location,
		private readonly state: TaskManagerStateService, private readonly router: Router,
		private readonly  userService: UsersService, private  readonly ngxUiLoaderService: NgxUiLoaderService,private readonly fga: FgaService,
	) { }

    /**
     * Builds the absolute url for the destination page
     * @param path Relative path of requested page
     * @returns Full destination url
     */
	getDestinationUrl(path: string): string {
		//debugger;
		// Absolute base url for the application (default to origin if base element not present)
		const baseElements = document.getElementsByTagName("base");
		const baseUrl = this.location.normalize(baseElements.length ? baseElements[0].href : window.location.origin);

		// Path of page (including hash, if using hash routing)
		const pathUrl = this.location.prepareExternalUrl(path);

		// Hash location strategy
		if (pathUrl.startsWith("#")) {
			return `${baseUrl}/${pathUrl}`;
		}

		// If using path location strategy, pathUrl will include the relative portion of the base path (e.g. /base/page).
		// Since baseUrl also includes /base, can just concatentate baseUrl + path
		return `${baseUrl}${path}`;
	}

	private loginInteractively(url: string): Observable<boolean> {
		if (this.msalGuardConfig.interactionType == InteractionType.Popup) { // NOSONAR
			return this.authService.loginPopup({ ...this.msalGuardConfig.authRequest })
				.pipe(
					map(() => true),

					catchError(() => of(false))
				);
		}
		const redirectStartPage = this.getDestinationUrl(url);
		this.authService.loginRedirect({
			redirectStartPage,
			scopes: [],
			...this.msalGuardConfig.authRequest,
		});
		return of(false);
	}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
		return this.authService.handleRedirectObservable()
			.pipe(
				concatMap(() => {
					// debugger

					if (!this.authService.getAllAccounts().length) {

						return this.loginInteractively(state.url);
					}
					return this.setUserInfo();
				}),
				catchError(() => {
					console.info("unatuhorized");
					this.router.navigate(['./unauthorized']);
					return of(false)
				})
			);
	}

	setUserInfo() {
		const unauth = '/unauthorized'
		const scopes =  environment.SCOPES
		const account = this.authService.getAllAccounts()[0];



		return this.authService.acquireTokenSilent({ scopes, account })
			.pipe(
				catchError(() => {
					console.info('error in acquireTokenSilent');
					if (this.msalInterceptorConfig.interactionType == InteractionType.Popup) { // NOSONAR
						return this.authService.acquireTokenPopup({ ...this.msalInterceptorConfig.authRequest, scopes });
					}
					const redirectStartPage = window.location.href;
					this.authService.acquireTokenRedirect({ ...this.msalInterceptorConfig.authRequest, scopes, redirectStartPage });
					return EMPTY;
				}),
				switchMap((result: AuthenticationResult) => {
					console.info(result.idToken);
					console.info("result===", result);
					


					const upn = result.idTokenClaims?.['upn'] || result.account?.username;
					const toyotaGUID = result.idTokenClaims?.['ToyotaGUID'];
					const name = String(result.idTokenClaims['name']);

					if (!toyotaGUID || !upn) {
						this.router.navigate([unauth]);
						return of(false);
					}
					sessionStorage.setItem('accessToken', result.accessToken);
					this.state.setGUIDState(toyotaGUID);
					localStorage.setItem('toyotaGUID', toyotaGUID);
					localStorage.setItem('name', name);
					return from(this.fga.fetchFgaDetails(toyotaGUID)).pipe(
						map((hasAccess: boolean) => {
						  if (!hasAccess) {
							this.router.navigate([unauth]);
						  }
						  return hasAccess;
						}),
						catchError(err => {
						  console.info('FGA fetch failed:', err);
						  this.router.navigate([unauth]);
						  return of(false);
						})
					  );
					
				})
			);
	}

	private getScopesForEndpoint(endpoint: string): Array<string> | null {
		const protectedResourcesArray = Array.from(this.msalInterceptorConfig.protectedResourceMap.keys());
		const keyMatchesEndpointArray = protectedResourcesArray.filter(key => {
			const minimatch = new Minimatch(key);
			return minimatch.match(endpoint) || endpoint.indexOf(key) > -1;
		});

		// process all protected resources and send the first matched resource
		if (keyMatchesEndpointArray.length > 0) {
			const keyForEndpoint = keyMatchesEndpointArray[0];
			if (keyForEndpoint) {
				return this.msalInterceptorConfig.protectedResourceMap.get(keyForEndpoint);
			}
		}

		return null;
	}

}

